import React, { useContext, useState } from 'react'
import { Button, Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'
import { clsUtils } from 'zlib-utils'
import BackEndAPI from '../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import InputText from '../../DevComponents/InputText'
import ClsFormatacao from '../../Utils/ClsFormatacao'
import ClsValidacao from '../../Utils/ClsValidacao'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../ImportBackend/Config/emDesenvolvimento'

interface PesquisaInterface {
  dataInicial: string
  dataFinal: string
  cpf: string
  numeroContrato: number | undefined
}

interface LogBaixaManualInterface {
  idLogBaixaManual: number
  idContratoParcela: number
  idContrato: number
  vencimento: string
  valor: number
  nomeCliente: string
  cpf: string
  nomeUsuario: string
  operacao: string
  dataRecebimento: string
  vrRecebido: number
  vrDescontoRecebido: number
  vrJurosRecebido: number
  vrMultaRecebido: number
  createdAt: string
}

export default function LogBaixasManuais() {

  const navigate = useNavigate()
  const clsApi = new BackEndAPI()
  const clsFormatacao = new ClsFormatacao()
  const clsValidacao = new ClsValidacao()

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  // const { mensagemState, setMensagemState } = contexto

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({
    dataInicial: '',
    dataFinal: '',
    cpf: '',
    numeroContrato: 0
  })

  const [rsLog, setRsLog] = useState<Array<LogBaixaManualInterface>>([])
  const [errosPesquisa, setErrosPesquisa] = useState<{ [key: string]: string }>({})

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    { campo: 'createdAt', cabecalho: 'Data/Hora', alinhamento: 'left', format: (v: string) => clsFormatacao.dataMillsToUser(parseInt(v)) },
    { campo: 'operacao', cabecalho: 'Operação', alinhamento: 'center', format: (v: string) => v === 'B' ? 'Baixa' : 'Cancelamento' },
    { campo: 'nomeUsuario', cabecalho: 'Usuário', alinhamento: 'left' },
    { campo: 'idContrato', cabecalho: 'Contrato', alinhamento: 'left' },
    { campo: 'nomeCliente', cabecalho: 'Cliente', alinhamento: 'left' },
    { campo: 'cpf', cabecalho: 'CPF', alinhamento: 'left' },
    { campo: 'vencimento', cabecalho: 'Vencimento', alinhamento: 'center', format: (v: string) => clsFormatacao.dataMillsToUser(parseInt(v)) },
    { campo: 'valor', cabecalho: 'Valor Parcela', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
    { campo: 'dataRecebimento', cabecalho: 'Dt. Recebimento', alinhamento: 'center', format: (v: string) => v ? clsFormatacao.dataMillsToUser(parseInt(v)) : '' },
    { campo: 'vrRecebido', cabecalho: 'Vr. Recebido', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
    { campo: 'vrDescontoRecebido', cabecalho: 'Desconto', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
    { campo: 'vrJurosRecebido', cabecalho: 'Juros', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
    { campo: 'vrMultaRecebido', cabecalho: 'Multa', alinhamento: 'right', format: (v: number) => clsFormatacao.currency(v) },
  ]

  const btFechar = () => navigate('/')

  const validarPesquisa = (): boolean => {
    let retorno = true
    let errs: { [key: string]: string } = {}

    retorno = clsValidacao.eData('dataInicial', pesquisa, errs, retorno, true)
    retorno = clsValidacao.eData('dataFinal', pesquisa, errs, retorno, true)

    if (retorno && pesquisa.dataInicial && pesquisa.dataFinal && pesquisa.dataInicial > pesquisa.dataFinal) {
      errs.dataInicial = 'Período inválido!'
      errs.dataFinal = 'Período inválido!'
      retorno = false
    }

    setErrosPesquisa(errs)
    return retorno
  }

  const onClickPesquisa = () => {
    if (!validarPesquisa()) return

    const dadosPesquisa: any = {}
    if (pesquisa.dataInicial) dadosPesquisa.dataInicial = pesquisa.dataInicial
    if (pesquisa.dataFinal) dadosPesquisa.dataFinal = pesquisa.dataFinal
    if (pesquisa.cpf) dadosPesquisa.cpf = pesquisa.cpf
    if (pesquisa.numeroContrato && pesquisa.numeroContrato > 0) dadosPesquisa.numeroContrato = pesquisa.numeroContrato

    const query = `
      getLogBaixasManuais(dados: ${clsUtils.ConverterEmGql(dadosPesquisa)}) {
        idLogBaixaManual
        idContratoParcela
        idContrato
        vencimento
        valor
        nomeCliente
        cpf
        nomeUsuario
        operacao
        dataRecebimento
        vrRecebido
        vrDescontoRecebido
        vrJurosRecebido
        vrMultaRecebido
        createdAt
      }
    `

    clsApi.query<Array<LogBaixaManualInterface>>(query, 'getLogBaixasManuais', 'Pesquisando log...', contexto)
      .then(rs => setRsLog(rs))
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 5 }}>
        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'center' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Log de Baixas Manuais
                <Typography variant="body2" gutterBottom>
                  Histórico de baixas e cancelamentos realizados manualmente
                </Typography>
              </Typography>
              <IconButton onClick={btFechar}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sm={3}>
              <InputText
                dados={pesquisa}
                field='dataInicial'
                label='Data Inicial'
                setState={setPesquisa}
                tipo='date'
                mask='00/00/0000'
                textAlign='right'
                erros={errosPesquisa}
              />
            </Grid>

            <Grid item xs={12} sm={3} sx={{ pl: { sm: 1 } }}>
              <InputText
                dados={pesquisa}
                field='dataFinal'
                label='Data Final'
                setState={setPesquisa}
                tipo='date'
                mask='00/00/0000'
                textAlign='right'
                erros={errosPesquisa}
              />
            </Grid>

            <Grid item xs={12} sm={3} sx={{ pl: { sm: 1 } }}>
              <InputText
                dados={pesquisa}
                field='cpf'
                label='CPF do Cliente'
                setState={setPesquisa}
                mask='cpf'
                erros={errosPesquisa}
                mapKeyPress={[{ key: 'Enter', onKey: onClickPesquisa }]}
              />
            </Grid>

            <Grid item xs={12} sm={2} sx={{ pl: { sm: 1 } }}>
              <InputText
                dados={pesquisa}
                field='numeroContrato'
                label='Nº Contrato'
                setState={setPesquisa}
                tipo='number'
                erros={errosPesquisa}
                mapKeyPress={[{ key: 'Enter', onKey: onClickPesquisa }]}
              />
            </Grid>

            <Grid item xs={12} sm={1} sx={{ pl: { sm: 1 }, mt: 2 }}>
              <Button fullWidth variant='contained' onClick={onClickPesquisa}>Pesquisar</Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 2 }}>
              <DataTable dados={rsLog} cabecalho={Cabecalho} acoes={[]} />
            </Grid>

          </Grid>
        </Paper>
        <ExibirJSONDev exibir={EMDESENVOLVIMENTO && false} oque={['pesquisa', pesquisa, 'rsLog', rsLog]} />
      </Container>
    </>
  )
}
